import { call, put, select, takeLatest, } from 'redux-saga/effects';

import { updateCheckoutComplete as actions, } from './actions';
import { orderOperations, } from '../order';
import * as types from './types';
import { repositories, } from 'api';
import { getChartToken, } from 'common/selectors';

export {
    actions,
};

const checkoutComplete = new repositories.CheckoutComplete();

function* updateCheckoutComplete() {
    try {
        const token = yield select(getChartToken);

        yield call([ checkoutComplete, 'update', ], token);

        yield put(actions.success());
    } catch (error) {}
}

function* fn() {
    yield put(orderOperations.request());
}

function* checkoutCompleteSaga() {
    yield takeLatest(types.UPDATE_CHECKOUT_COMPLETE_REQUEST, updateCheckoutComplete);
    yield takeLatest(types.UPDATE_CHECKOUT_COMPLETE_SUCCEEDED, fn);
}

export default checkoutCompleteSaga;
